
let styles = {
  container: {
    padding: '4%',
    display: 'flex',
    justifyContent: 'center',
  },

  table: {
    backgroundColor: '#F2F2F2',
    padding: '2%',
  },

  items: {
    padding: '1%',
    display:'flex',
    flexDirection:'row'
  },

  item_header: {
    fontSize: '120%',
    fontWeight: 600,
    paddingLeft: '10%',
    width: '40%'
  },

  item_body: {
    padding: '6px ',
    width: '100%'
  },

  main_header: {
    padding: '1%',
    marginBottom: '3%',
    backgroundColor: '#32B6A7',
  },

  button_submit: {
    padding: '1%',
    justifyContent: 'center',
    display: 'flex',
    paddingTop: '6%',
  },

  input: {
    width: '50%',
  },

  success: {
    textAlign: 'center',
    fontSize: '120%',
    fontWeight: 800,
  }
}
export default styles



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addLeadBulk/style.js